import React from 'react';
import { Radio as AntRadio } from 'antd';
import type { RadioProps } from 'antd';
import clsx from 'clsx';

/**
 * Thin wrapper over the Antd Radio (per the antd wrapper standardization plan):
 * single import source through @common/components and a `wk-radio` class hook.
 */
export const Radio = ({ className, ...props }: RadioProps) => (
  <AntRadio {...props} className={clsx('wk-radio', className)} />
);

Radio.Group = AntRadio.Group;
Radio.Button = AntRadio.Button;
